import Accordion from '@/common/components/Accordion';
import { CompanyData } from '@/features/companies/types/companies.type';
import { equipmentDriverLicenseRequirementsForConsumption } from '@/features/privateCompanies/constants/politics/generalPolitics/equipmentDriverLicenseRequirementsForConsumption.constant';
import { logReasonRequirement } from '@/features/privateCompanies/constants/politics/generalPolitics/logReasonRequirement.constant';
import { trackIntegrationMode } from '@/features/privateCompanies/constants/politics/generalPolitics/trackIntegrationMode.constant';
import { companyPriceSurveyMode } from '@/features/privateCompanies/constants/priceSurvey/companyPriceSurveyMode.constant';
import { UpdateGeneralPoliticsModal } from '@/features/privateCompanies/pages/Update/components/UpdateGeneralPoliticsModal';
import { CircleChevronDownIcon } from 'lucide-react';
import { requireBillReview } from '../constants/requireBillReview.constant';

const GeneralPoliticsSection = ({ company }: { company?: CompanyData }) => {
  const generalItems = [
    {
      label: 'Impressora responsável pelos cartões da empresa',
      value: company?.printer_machine?.display_name,
      testId: 'printer_machine',
    },
    {
      label: 'Timezone',
      value: company?.time_zone ? `${company?.time_zone?.display_name} (${company?.time_zone?.offset})` : '--',
      testId: 'time_zone',
    },
    {
      label: 'Pesquisa de preço',
      value: company?.price_survey_mode ? companyPriceSurveyMode[company?.price_survey_mode] : '--',
      testId: 'price_survey_mode',
    },
    {
      label: 'Modo de integração do rastreador',
      value: company?.tracker_integration_mode ? trackIntegrationMode[company?.tracker_integration_mode] : '--',
      testId: 'tracker_integration_mode',
    },
    {
      label: 'Solicitar motivo na edição de equipamento',
      value: company?.update_equipment_log_reason_requirement ? logReasonRequirement[company?.update_equipment_log_reason_requirement] : '--',
      testId: 'update_equipment_log_reason_requirement',
    },
    {
      label: 'Solicitar motivo na edição de usuário',
      value: company?.update_user_log_reason_requirement ? logReasonRequirement[company?.update_user_log_reason_requirement] : '--',
      testId: 'update_user_log_reason_requirement',
    },
    {
      label: 'Quantidade máxima de cartões',
      value: company?.cards_quota ? company?.cards_quota.toLocaleString() : '--',
      testId: 'cards_quota',
    },
    {
      label: 'Validar compatibilidade da CNH',
      value: company?.equipment_driver_license_requirements_for_consumptions ? equipmentDriverLicenseRequirementsForConsumption[company?.equipment_driver_license_requirements_for_consumptions] : '--',
      testId: 'equipment_driver_license_requirements_for_consumptions',
    },
    {
      label: 'Permitir rejeição de NF pelo cliente',
      value: company?.require_bill_review ? requireBillReview[company.require_bill_review] : '',
      testId: 'require_bill_review',
    }
  ];

  return (
    <Accordion
      defaultOpen
      head={(
        <div className="flex items-center gap-x-3">
          <div onClick={(e) => e.stopPropagation()}>
            <UpdateGeneralPoliticsModal company={company} />
          </div>

          <p className='text-xl'>
            Geral
          </p>
        </div>
      )}
      triggerClassName="py-0"
      bodyClassName="pt-4 pb-0"
      body={(
        <div className='flex flex-col gap-4'>
          {generalItems.map((item, i) => (
            <div key={`general_politics_${i}`} className='flex items-center gap-2'>
              <p>
                {item.label}:
              </p>

              <div className='flex items-center gap-1 text-white-400'>
                <CircleChevronDownIcon strokeWidth={1.5} />

                <p data-testid={item.testId}>
                  {item.value || '--'}
                </p>
              </div>
            </div>
          ))}
        </div>
      )}
    />
  )
}

export default GeneralPoliticsSection;
